import { useMemo } from 'react'

import { useGetFacebookAdAccounts } from '../../../../../api/getFacebookAdAccounts'
import { useGetFacebookAdSets } from '../../../../../api/getFacebookAdSets'
import { AccountId } from '../../../../../models'

export const useSelectAdsRequests = ({
  accountId,
  selectedAdAccount,
  setSelectedAdAccount,
  dontGetAdSets,
}: {
  accountId: number
  selectedAdAccount: number | undefined
  setSelectedAdAccount: (a: number) => void
  dontGetAdSets?: boolean
}) => {
  const { data: adAccounts } = useGetFacebookAdAccounts({
    connectionId: accountId,
    config: {
      onSuccess(data) {
        if (!(data instanceof Error) && data.adAccounts[0]) {
          const selectedAccounts = filterSelectedAccounts(data.adAccounts)
          setSelectedAdAccount(selectedAccounts[0].id)
        }
      },
    },
  })

  const filterSelectedAccounts = (accounts: AccountId[]) => {
    return accounts.filter((account) => account.selected)
  }

  const accounts = useMemo(() => {
    return adAccounts instanceof Error || !adAccounts?.adAccounts
      ? []
      : filterSelectedAccounts(adAccounts.adAccounts)
  }, [adAccounts])

  const accountOptions = useMemo(() => {
    return accounts.map((account) => ({
      value: `${account.id}`,
      label: account.name,
    }))
  }, [accounts])

  const { data: adSetsData } = useGetFacebookAdSets({
    connectionId: accountId,
    adAccountId: selectedAdAccount,
    config: {
      enabled: !!selectedAdAccount && !dontGetAdSets,
    },
  })

  const adSets = useMemo(() => {
    return adSetsData instanceof Error || !adSetsData?.adSets ? [] : adSetsData.adSets
  }, [adSetsData])

  const selectedAccountOption = useMemo(() => {
    return accountOptions.find((option) => option.value === selectedAdAccount?.toString())
  }, [accountOptions, selectedAdAccount])

  const isAdAccountsAdSetsAutoProtected = accounts.find(
    (account) => account.id === selectedAdAccount
  )?.protectAllAdSets

  return { accountOptions, adSets, selectedAccountOption, isAdAccountsAdSetsAutoProtected }
}
